import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260326_add_labels_to_content_templates",
  description: "Add labels field to content template instances",
  apply(json: any): any {
    const contentTemplateInstances = json.contentTemplateInstances ?? {};
    for (const id of Object.keys(contentTemplateInstances)) {
      if (!contentTemplateInstances[id].labels) {
        contentTemplateInstances[id].labels = {};
      }
    }

    return json;
  },
};

export default migration;
